import Vue from 'vue'
import VueMeta from 'vue-meta'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import App from './App.vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element'
import axios from 'axios'
import router from './router'
import VueGtag from "vue-gtag";
import Notifications from 'vue-notification'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(vueCustomElement);
Vue.use(VueMeta);
Vue.use(VueGtag, {
    config: {id: process.env.VUE_APP_GTAG_ID}
});
Vue.use(Notifications);
App.router = router;

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

const accountId = document.getElementsByTagName('subscriber-widget')[0].getAttribute("account-id");
const cssId = document.getElementsByTagName('subscriber-widget')[0].getAttribute("css-id");
axios.get(`/account/${accountId}/css/${cssId}`).then(data => {
    console.log('Success')
    let css = '';
    if (data && data.data && data.data.status) {
        css = data.data.value.css;
    }
    axios.get(`${process.env.VUE_APP_SELF_HOST}/css/app.css?v=${new Date().getTime()}`).then(data => {
        Vue.customElement('subscriber-widget', App, {
            shadow: true,
            shadowCss: `${data.data} ${css}`,
        });
    });
}).catch(() => {
    console.log('Error')
    axios.get(`${process.env.VUE_APP_SELF_HOST}/css/app.css?v=${new Date().getTime()}`).then(data => {
        Vue.customElement('subscriber-widget', App, {
            shadow: true,
            shadowCss: `${data.data}`,
        });
    });
});

/*Vue.customElement('subscriber-widget', App, {
    shadow: false,
});*/
